export const getColorToken = (token: `--color-${string}`) =>
  getComputedStyle(document.documentElement).getPropertyValue(token).trim();
